import { type App, defineAsyncComponent } from 'vue'

const components = {
  DashboardCampaignCell: defineAsyncComponent(() => import('./DashboardCampaignCell.vue')),
  DashboardCampaigns: defineAsyncComponent(() => import('./DashboardCampaigns.vue')),
  DashboardInbox: defineAsyncComponent(() => import('./DashboardInbox.vue')),
  DashboardInboxRow: defineAsyncComponent(() => import('./DashboardInboxRow.vue')),
  DashboardStats: defineAsyncComponent(() => import('./DashboardStats.vue')),
  DashboardWeekStrip: defineAsyncComponent(() => import('./DashboardWeekStrip.vue'))
}

type Registry = typeof components

declare module 'vue' {
  interface GlobalComponents extends Registry {}
}

export const registerComponents = (app: App) => {
  for (const [name, component] of Object.entries(components)) {
    app.component(name, component)
  }
}
